import { Injectable } from '@angular/core';
import { MyLog } from '@common/common';
import { InputFieldSizes } from '@common/input-definitions';
import { getDateFor } from '@util/date-utils';
import { isJsObject, isNonEmptyString } from '@util/utils';
import { Observable, Subject } from 'rxjs';

export type isAdminType = boolean | null;

export const enum CONFIG_KEYS {
  IMAGE_CONVERT = 'imageConvert',
  ORDER_START_DATE = 'order_search_start',
  ORDER_END_DATE = 'order_search_end',
  TEAM_PLAN_START_DATE = 'team_plan_search_start',
  TEAM_PLAN_END_DATE = 'team_plan_search_end',
};

function ael(n: string, fn: any) {
  window.addEventListener(n, fn);
}

@Injectable({
  providedIn: 'root'
})
export class StateService {

  private _isAdmin: isAdminType = false;

  private _isOnline = false;

  private adminSub = new Subject<isAdminType>();

  private configSub = new Subject<boolean>();

  private mobileSub = new Subject<boolean>();

  private conSub = new Subject<boolean>();

  private teamsSub = new Subject<any[]>();

  private teams: any[] = [];

  public isLoggedId = false;

  public isMobile = false;

  public isAppLoading = true;

  private stateKnown = false;

  constructor() {
    this.isDevMode() && MyLog.log('Debug mode!');

    try {
      const cb = (value: boolean) => {
        this.signalConnectionChange(value);
      };
      ael('offline', (ev: any) => {
        cb(false);
      });
      ael('online', (ev: any) => {
        cb(true);
      });
    } catch (e) {
    }
  }

  signalConnectionChange(online: boolean) {
    this._isOnline = online;
    this.conSub.next(this._isOnline);
  }

  connected(): Observable<boolean> {
    return this.conSub.asObservable().pipe();
  }

  getFieldSize(fieldName: string): number | null {
    if (InputFieldSizes.hasOwnProperty(fieldName) &&
      Number.isInteger(InputFieldSizes[fieldName])) {
      return InputFieldSizes[fieldName];
    }
    return null;
  }

  getTeams(): any[] {
    return this.teams;
  }

  isAdmin() {
    return this._isAdmin;
  }

  isDevMode() {
    if (window.localStorage) {
      const result = window.localStorage.getItem('debug');
      return result === '1';
    }
    return false;
  }

  setMobile(isMobile: boolean) {
    this.isMobile = isMobile;
    this.mobileSub.next(this.isMobile);
  }

  setIsAdmin(isAdmin: boolean) {
    this._isAdmin = isAdmin;
    this.adminSub.next(isAdmin);
  }

  setTeams(teams: any[] = []) {
    this.teams = teams;
    this.teamsSub.next(teams);
  }

  adminChange(): Observable<boolean | null> {
    return this.adminSub.asObservable();
  }

  configChange(): Observable<boolean> {
    return this.configSub.asObservable();
  }

  mobileChange(): Observable<boolean> {
    return this.mobileSub.asObservable();
  }

  teamsChange(): Observable<any[]> {
    return this.teamsSub.asObservable();
  }

  configuration: any = {
    order_search_start: "now",
    order_search_end: "start,+1month",
    team_plan_search_start: "now",
    team_plan_search_end: "start,+1month",
  };

  setConfiguration(config: any) {
    if (!isJsObject(config)) {
      return;
    }
    //MyLog.log('CONFIG:', config);

    this.configuration = Object.assign(
      this.configuration,
      config
    );
    this.configSub.next(true);
  }

  getConfigurationFor(key: string, value?: any) {

    let useKey = true;
    let secondValue: any;

    switch (key) {
      case CONFIG_KEYS.ORDER_START_DATE:
      case CONFIG_KEYS.TEAM_PLAN_START_DATE:
        break;
      case CONFIG_KEYS.ORDER_END_DATE:
        secondValue = this.getConfigurationFor(CONFIG_KEYS.ORDER_START_DATE);
        break;
      case CONFIG_KEYS.TEAM_PLAN_END_DATE:
        secondValue = this.getConfigurationFor(CONFIG_KEYS.TEAM_PLAN_START_DATE);
        break;
        case CONFIG_KEYS.IMAGE_CONVERT:
          return this.configuration[key];
      default:
        useKey = false;
    }

    if (useKey) {
      const configValue = this.configuration[key];
      if (isNonEmptyString(configValue)) {
        return getDateFor(configValue, secondValue);
      }
    }
    return;
  }

  stateKnownSub = new Subject<boolean>();

  setStateKnown(ok: boolean) {
    this.stateKnown = ok;
    this.stateKnownSub.next(ok);
  }

  whenStateKnown(): Promise<boolean> {
    if (this.stateKnown) {
      //MyLog.log('STATE:D:', true);
      return Promise.resolve(true);
    }

    return new Promise((resolve: (value: boolean) => void) => {
      const sub = this.stateKnownSub.subscribe((ok: boolean) => {
        //MyLog.log('STATE:S:', ok);
        resolve(ok);
        sub && sub.unsubscribe();
      })
    });
  }

  getLocalConfiguration(key:string) {
    const ls = this.getLS();
    return ls.getItem(key);
  }

  setLocalConfiguration(key:string, value:any) {
    const ls = this.getLS();
    ls.setItem(key, value);
  }

  getLS() {
    let e = function (param?:any) {};
    return window.localStorage || {
      isDummy:true,
      getItem: e,
      setItem: e,
      removeItem: e
    };
  }
}

